import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// hooks
import { onClickOutside, useWindowScroll } from '@vueuse/core'

interface HeaderDesktopReturn {
  refRoot: Ref<HTMLElement | null>
  refOpenIndex: Ref<number | null>
  refIsScrolled: ComputedRef<boolean>
  open: (index: number) => void
  close: (index: number) => void
}

export const useHeaderDesktop = (): HeaderDesktopReturn => {
  const refRoot = ref<HTMLElement | null>(null)
  const refOpenIndex = ref<number | null>(null)

  const { y } = useWindowScroll()
  const refIsScrolled = computed<boolean>(() => y.value > 0)

  const open = (index: number): void => {
    refOpenIndex.value = index
  }

  const close = (index: number): void => {
    if (refOpenIndex.value === index) refOpenIndex.value = null
  }

  const closeAll = (): void => {
    refOpenIndex.value = null
  }

  onClickOutside(refRoot, closeAll)

  const handleKey = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') closeAll()
  }

  onMounted(() => document.addEventListener('keydown', handleKey))
  onBeforeUnmount(() => document.removeEventListener('keydown', handleKey))

  return {
    refRoot,
    refOpenIndex,
    refIsScrolled,
    open,
    close,
  }
}